import { jsx as _jsx } from "react/jsx-runtime";
import { useRef } from 'react';
import { ShopList } from './shop-list';
import { useShopAssignmentForm } from './use-shop-assignment-form';
import { useAssignmentUpdate } from './use-assignment-update';
export var ShopAssignmentsContainer = function (props) {
    var form = useShopAssignmentForm(props.shops, props.tax).form;
    var taxRef = useRef(null);
    taxRef.current = props.tax;
    var updateShopTaxAssignment = useAssignmentUpdate(taxRef);
    return (_jsx(ShopList, { form: form, shops: props.shops, readonly: props.shops.length <= 1, allowSelectAll: props.shops.length > 1, updateShopTaxAssignment: updateShopTaxAssignment }));
};
